import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DSBreakerPS, DSForceCooling, DsPanelIP, MultiOptDetails_2DS, MultiOptDetails_3DS, MultiOptDetails_4DS, MultiOptDetails_8DS, MultiOptDetails_9DS, OptionsConnectedDef, OptionsDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-panel',
  templateUrl: './ds-panel.component.html',
  styleUrls: ['./ds-panel.component.css']
})
export class DsPanelComponent implements OnInit, OnChanges {

  @Input() dsPanelObj: DsPanelIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  showInfoMsg: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields:boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
    let _dsType = this.dsPanelObj.parentDSRef.dataSheetType;
    this.dsPanelObj.prodType = _dsType;
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType ===(UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType ===(UserType.MARKETING) || this._dataService.userType ===(UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType ===(UserType.MECHANICAL_ENGINEERING) || this._dataService.userType ===(UserType.MARKETING) || this._dataService.userType ===(UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType ===(UserType.PROJECT_MANAGEMENT) || this._dataService.userType ===(UserType.MARKETING) || this._dataService.userType ===(UserType.SUPER_ADMIN);
    if (!this.dsPanelObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }
  }

  cachedVCB: any = {};
  filterVCB(_pdTyp) {
    let _id = this._dataService.getProductVariantId_DS(_pdTyp);
    if (this.cachedVCB[_id] != null) {
      return this.cachedVCB[_id];
    }
    this.cachedVCB[_id] = this._dataService.vcbModel.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    if (this.cachedVCB[_id] != null) {
      return this.cachedVCB[_id];
    }
    var _result = !this._dataService.isGeneralVcbModel(_id);
    this.cachedVCB[_id] = _result;
    return _result;
  }

  cachedVCBDetail: any = {};
  filterVCBDetail(_pdTyp) {
    let _id = this._dataService.getProductVariantId_DS(_pdTyp);
    if (this.cachedVCBDetail[_id] != null) {
      return this.cachedVCBDetail[_id];
    }
    this.cachedVCBDetail[_id] = this._dataService.vcbModelDetail.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    if (this.cachedVCBDetail[_id] != null) {
      return this.cachedVCBDetail[_id];
    }
    var _result = !this._dataService.isGeneralVcbModelDetail(_id);
    this.cachedVCBDetail[_id] = _result;
    return _result;
  }

  cachedRackInOut: any = {};
  filterRackInOut() {
    let _id = this._dataService.getProductVariantId_DS(this.dsPanelObj.prodType);
    if (this.cachedRackInOut[_id] != null) {
      return this.cachedRackInOut[_id];
    }
    this.cachedRackInOut[_id] = this._dataService.rackInOutMech.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    if (this.cachedRackInOut[_id] != null) {
      return this.cachedRackInOut[_id];
    }
    var _result = !this._dataService.isGeneralRackInOutMech(_id);
    this.cachedRackInOut[_id] = _result;
    return _result;
  }

    checkRackInOutInfoMsg() {
      let _vcbTmp = this._dataService.getVcbDetailName(this.dsPanelObj.vcbModelDetail);
      let _rackTmp = this.dsPanelObj.rackInOutMech;
      if (_vcbTmp.includes("Convac") && _rackTmp === "002") { // CONVAC and Motorized
        this.showInfoMsg = true;
      }
      else {
        this.showInfoMsg = false;
      }
    }

  cachedforceCoolVCBCurr: any = {};
  filterforceCoolVCBCurr() {
    let _id = this._dataService.getProductVariantId_DS(this.dsPanelObj.prodType);
    if (this.cachedforceCoolVCBCurr[_id] != null) {
      return this.cachedforceCoolVCBCurr[_id];
    }
    this.cachedforceCoolVCBCurr[_id] = this._dataService.forceCoolingVCBCurr.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedforceCoolVCBCurr[_id];
    if (this.cachedforceCoolVCBCurr[_id] != null) {
      return this.cachedforceCoolVCBCurr[_id];
    }
    var _result = !this._dataService.isGeneralForceCoolingVCBCurr(_id);
    this.cachedforceCoolVCBCurr[_id] = _result;
    return _result;
  }

  cachedSCC: any = {};
  filterSCC(_id: string) {
    if (this.cachedSCC[_id] != null) {
      return this.cachedSCC[_id];
    }
    this.cachedSCC[_id] = this._dataService.singleCoreCables.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedSCC[_id];
    if (this.cachedSCC[_id] != null) {
      return this.cachedSCC[_id];
    }
    var _result = !this._dataService.isGeneralSingleCoreCables(_id);
    this.cachedSCC[_id] = _result;
    return _result;
  }


  filterGasDuct() {
    let _id = this.dsPanelObj.parentDSRef.dsGeneralIP.internalArcRating;

    let _time = this._dataService.extractSeconds(_id);
    let _result = [];
    if (_time == 1) {
      _result = this._dataService.applicabilityOptions.filter(app => app.applicId == "001");
    }
    else if (_time == 0.1) {
      _result = this._dataService.applicabilityOptions.filter(app => app.applicId == "002");
    }
    else {
      _result = this._dataService.applicabilityOptions;
    }

    return _result;
  }


  cachedFeederBP: any = {};
  filterFeederBP(_pdTyp) {
    let _id = this._dataService.getProductVariantId_DS(_pdTyp);
    if (this.cachedFeederBP[_id] != null) {
      return this.cachedFeederBP[_id];
    }
    this.cachedFeederBP[_id] = this._dataService.feederRatingBP.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedFeederBP[_id];
    if (this.cachedFeederBP[_id] != null) {
      return this.cachedFeederBP[_id];
    }
    var _result = !this._dataService.isGeneralFeederRatingBP(_id);
    this.cachedFeederBP[_id] = _result;
    return _result;
  }

  cachedFeederNBP: any = {};
  filterFeederNBP(_pdTyp) {
    let _id = this._dataService.getProductVariantId_DS(_pdTyp);
    if (this.cachedFeederNBP[_id] != null) {
      return this.cachedFeederNBP[_id];
    }
    this.cachedFeederNBP[_id] = this._dataService.feederRatingBP.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedFeederNBP[_id];
    if (this.cachedFeederNBP[_id] != null) {
      return this.cachedFeederNBP[_id];
    }
    var _result = !this._dataService.isGeneralFeederRatingBP(_id);
    this.cachedFeederNBP[_id] = _result;
    return _result;
  }

  checkApplicabilityForDetails(_fdrDS: MultiOptDetails_9DS) {
    if (_fdrDS.type1 != null) {
      if(_fdrDS.type1 == "007"){
        return true;
      }
      else{
        _fdrDS.type2 = "";
        return false;
      }
    }
  }
changeCurrRating(_fdrDS: MultiOptDetails_9DS) {
    _fdrDS.type8 = "";
    _fdrDS.type9 = "";
  }

  checkFeederRatingBreakerPanChange(_fdrDS: MultiOptDetails_9DS) {
    _fdrDS.type2 = "";
    _fdrDS.type3 = "";
  }

  resetBreakerPS(_fdrDS: MultiOptDetails_9DS) {
    _fdrDS.type9 = "";
  }

  filterSwitching(_fdrDS: MultiOptDetails_9DS) {
    let _list = this._dataService.switchingList;
    if(_fdrDS.type1 == "005" || _fdrDS.type1 == "007"){ // Capacitor or Other
      return _list;
    }
    else{
      return _list.filter(opt => opt.optionId != "002"); // Filter out B2B
    }
  }

  addNewFeederRatingBreakerPanBlock() {
    this.dsPanelObj.addFeederRBPDS(new MultiOptDetails_9DS("", "", "001", "", "", "", "", "", ""));
  }
  removeFeederRatingBreakerPanBlock(_crDS: MultiOptDetails_9DS) {
    if (_crDS) {
      this.dsPanelObj.removeFeederRBPDS(_crDS);
    }
  }

  cachedPnlWd: any = {};
  filterPnlWd(_pdTyp, _frBp) { // Used for both Panel Width and Feeder Non Breaker Type
    let _tmpPW;
    
    let _tmpfrBp = this._dataService.getFeederRatingBPName(_frBp);
    _tmpPW = this._dataService.extractAmpere(_tmpfrBp);

    let _shrtCurr = this.dsPanelObj.parentDSRef.dsGeneralIP.shortTimeCurrRating.split(" ")[0];

    return this.dsPanelObj.filterPanelWidth(_pdTyp, _tmpPW, _shrtCurr);
  }

  filterBreakerPS(_fdrDS: MultiOptDetails_9DS) {

    let rated_volt = this._dataService.extractNumberKv(this.dsPanelObj.parentDSRef.dsGeneralIP.ratedVoltage);
    let dry_freq = this._dataService.extractNumberKv(this.dsPanelObj.parentDSRef.dsGeneralIP.dryFrqWithstdVolt);
    let rated_imp_volt = this._dataService.extractNumberKv(this.dsPanelObj.parentDSRef.dsGeneralIP.ratedImpulseVoltage);
    let shrt_time_curr = this.dsPanelObj.parentDSRef.dsGeneralIP.shortTimeCurrRating;
    let prod_type = this._dataService.getProductVariantId_DS(this.dsPanelObj.prodType);

    let _tmp_shrtCurr = this._dataService.extractNumberkA(shrt_time_curr);
    let _timeSec = this._dataService.extractSeconds(shrt_time_curr);
    let _tmpPW = this._dataService.extractAmpere(this._dataService.getFeederRatingBPName(_fdrDS.type7));

    let _result: Array<DSBreakerPS> = [];
    _result = this._dataService.dsBreakerPS.filter(opt =>
      parseFloat(opt.rtd_volt) === rated_volt &&
      parseFloat(opt.dry_freq) === dry_freq &&
      parseFloat(opt.rated_imp_volt) === rated_imp_volt &&
      parseFloat(opt.shrt_time_curr) === _tmp_shrtCurr &&
      parseFloat(opt.shrt_time_curr_sec) === _timeSec &&
      opt.prod_type === prod_type &&
      opt.switch_type === _fdrDS.type3 &&
      this._dataService.compareTwoInputs_v2(parseFloat(opt.vcb_curr), this._dataService.getFeederRatingBPName(_fdrDS.type7), _tmpPW) &&
      opt.panel_width === _fdrDS.type8 &&
      opt.rack_type === this.dsPanelObj.rackInOutMech
    );

    return _result;
  }
  checkBreakerPSAvailability(_fdrDS: MultiOptDetails_9DS) {
    let _result = this.filterBreakerPS(_fdrDS);
    let rated_volt = this._dataService.extractNumberKv(this.dsPanelObj.parentDSRef.dsGeneralIP.ratedVoltage);
    let dry_freq = this._dataService.extractNumberKv(this.dsPanelObj.parentDSRef.dsGeneralIP.dryFrqWithstdVolt);
    let rated_imp_volt = this._dataService.extractNumberKv(this.dsPanelObj.parentDSRef.dsGeneralIP.ratedImpulseVoltage);
    let shrt_time_curr = this.dsPanelObj.parentDSRef.dsGeneralIP.shortTimeCurrRating;
    let prod_type = this._dataService.getProductVariantId_DS(this.dsPanelObj.prodType);

    let _tmp_shrtCurr = this._dataService.extractNumberkA(shrt_time_curr);
    let _timeSec = this._dataService.extractSeconds(shrt_time_curr);
    let _tmpPW = this._dataService.extractAmpere(this._dataService.getFeederRatingBPName(_fdrDS.type7));
    let _rackInOutMech = this.dsPanelObj.rackInOutMech;

    if (rated_volt && dry_freq && rated_imp_volt && shrt_time_curr && prod_type && _rackInOutMech &&
       _tmp_shrtCurr && _timeSec && _tmpPW &&
       _fdrDS.type3 && _fdrDS.type7 && _fdrDS.type8) {
      if (_result.length == 0) return true;

    }
    return false;
  }

  filterForceCooling() {
    let bus_curr = this._dataService.extractAValue(this.dsPanelObj.parentDSRef.dsGeneralIP.switchboardCurrRating);
    let vcb_curr = this._dataService.getForceCoolingVCBCurrName(this.dsPanelObj.forceCoolingVCBCurr);
    let vcb_pole = this._dataService.getVcbPoleName(this.dsPanelObj.vcbPole);
    let amb_temp = (this.dsPanelObj.parentDSRef.dsGeneralIP.ambTempDesign).split(" ")[0];
    let main_busbar = this._dataService.getMaterialMBBName(this.dsPanelObj.parentDSRef.dsBusbarsIP.mainBusDropper);
    let prod_type = this._dataService.getProductVariantId_DS(this.dsPanelObj.prodType);

    let _result: Array<DSForceCooling> = [];
    _result = this._dataService.forceCooling.filter(opt => {
      const cond1 = this._dataService.compareTwoInputs(parseFloat(bus_curr), opt.bus_curr);
      const cond2 = (vcb_curr).includes(opt.vcb_curr);
      const cond3 = (opt.vcb_pole.includes("-")) ? true : opt.vcb_pole === vcb_pole;
      const cond4 = (opt.amb_temp.includes("-")) ? true : this._dataService.compareTwoInputs(parseFloat(amb_temp), opt.amb_temp);
      const cond5 = (opt.main_busbar.includes("-")) ? true : opt.main_busbar === main_busbar;
      const cond6 = opt.prod_type == prod_type;
      return cond1 && cond2 && cond3 && cond4 && cond5 && cond6;
    });

    return _result;
  }

  filterFrcCoolApplicability() {
    let _selectedOptions = this.filterForceCooling();

    let _result = this._dataService.applicabilityOptions.filter(app =>
      _selectedOptions.findIndex(opt => opt.applic_id === app.applicId) >= 0
    );
    return _result;
  }

  filterFrcCoolLocOfFans() {
    let _selectedOptions = this.filterForceCooling();
    // Collect all unique location_of_fans IDs from selected options
    let fanIds: Set<string> = new Set();
    _selectedOptions.forEach(opt => {
      if (Array.isArray(opt.location_of_fans)) {
        opt.location_of_fans.forEach((id: string) => fanIds.add(id));
      }
    });
    // Filter locationOfFans by IDs present in fanIds
    let _result = this._dataService.locationOfFans.filter((fan: OptionsDef) => fanIds.has(fan.optionId));
    return _result;
  }

  addNewfeederTypeNonBreakerBlock() {
    this.dsPanelObj.addFeederNbDS(new MultiOptDetails_3DS("", "", ""));
  }
  removefeederTypeNonBreakerBlock(_crDS: MultiOptDetails_3DS) {
    if (_crDS) {
      this.dsPanelObj.removeFeederNbDS(_crDS);
    }
  }

  cachedNBWd: any = {};
  filterNBWd(_pdTyp, _frBp, _typ) { // Used for both Panel Width and Feeder Non Breaker Type
    let _tmpPW;
    
    let _tmpfrBp = this._dataService.getFeederRatingBPName(_frBp);
    _tmpPW = this._dataService.extractAmpere(_tmpfrBp);

    let _shrtCurr = this.dsPanelObj.parentDSRef.dsGeneralIP.shortTimeCurrRating.split(" ")[0];

    return this.dsPanelObj.filterNonBPWidth(_pdTyp, _tmpPW, _shrtCurr,_typ);
  }

  checkFeederRatingBPSelection(_fdrDS: MultiOptDetails_4DS) {
    if (_fdrDS.type2 != null) {
      let _feederBP_Amp = this._dataService.extractAmpere(this._dataService.getFeederRatingBPName(_fdrDS.type2));
      let _busRating_Amp = this._dataService.extractAValue(this.dsPanelObj.parentDSRef.dsGeneralIP.switchboardCurrRating);
      if (_feederBP_Amp > parseFloat(_busRating_Amp)) {
        return true;
      }else {
        return false;
      }
    }
  }

  changeCurrRatingNBP(_fdrDS: MultiOptDetails_3DS) {
    _fdrDS.type3 = "";
  }

 sectionNoteChangePM(_event: any) {
    this.dsPanelObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsPanelObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsPanelObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    console.log("thi.ds.dsPanelObj", this.dsPanelObj);
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
            let _validList: Array<ValidationItem> = [];

            // PM access group (fields with hasAccessPM)
            if (this.hasAccessPM) {
              _validList.push(
                new ValidationItem("VCB Model Name", !!this.dsPanelObj.vcbModelName, " required to save Datasheet."),
                new ValidationItem("Rack-in/Rack-out Mechanism", !!this.dsPanelObj.rackInOutMech, " required to save Datasheet."),
                new ValidationItem("PM Note", !!this.dsPanelObj.sectionNotePM, " required to save Datasheet.")
              );
              if (this.dsPanelObj.isVcbSpecReqApplicable) {
                _validList.push(new ValidationItem("VCB Model Details", !!this.dsPanelObj.vcbModelDetail, " required to save Datasheet."));
                }
            }

            // ME access group (fields with hasAccessME)
            if (this.hasAccessME) {
              _validList.push(
                new ValidationItem("VCB Type", !!this.dsPanelObj.vcbType, " required to save Datasheet."),
                new ValidationItem("VCB Pole", !!this.dsPanelObj.vcbPole, " required to save Datasheet."),
                new ValidationItem("For Enclosure", !!this.dsPanelObj.forEnclosure, " required to save Datasheet."),
                new ValidationItem("For LV Compartment Door", !!this.dsPanelObj.forLVCompDoor, " required to save Datasheet."),
                new ValidationItem("Castle Lock for Panel Interlocking", !!this.dsPanelObj.castleLock, " required to save Datasheet."),
                new ValidationItem("Rear Cover", !!this.dsPanelObj.rearCover, " required to save Datasheet."),
                new ValidationItem("Extensible Both Sides", !!this.dsPanelObj.extBothSides, " required to save Datasheet."),
                new ValidationItem("Power Cable", !!this.dsPanelObj.powerCable, " required to save Datasheet."),
                new ValidationItem("Control Cable", !!this.dsPanelObj.controlCable, " required to save Datasheet."),
                new ValidationItem("Bustduct", !!this.dsPanelObj.busduct, " required to save Datasheet."),
                new ValidationItem("Force Cooling Applicability", !!this.dsPanelObj.forceCoolingApplic, " required to save Datasheet."),
                new ValidationItem("Single Core Cables", !!this.dsPanelObj.singleCoreCables, " required to save Datasheet."),
                new ValidationItem("Gas Duct Exhaust", !!this.dsPanelObj.gasductExh, " required to save Datasheet."),
                new ValidationItem("Silver Plating at Joints", !!this.dsPanelObj.silverPlatingatJoints, " required to save Datasheet."),
                new ValidationItem("ME Note", !!this.dsPanelObj.sectionNoteME, " required to save Datasheet.")
              );
              if(this.dsPanelObj.isBusductApplicable){
                _validList.push(new ValidationItem("Busduct Entry", !!this.dsPanelObj.busductEntry, " required to save Datasheet."));
                _validList.push(new ValidationItem("Feeder Name Applicable for Busduct", !!this.dsPanelObj.feederNameAppli, " required to save Datasheet."));
              }
              if(this.dsPanelObj.isLvCompDrSpecReqApplicable){
                _validList.push(new ValidationItem("For LV Compartment Door Details", !!this.dsPanelObj.forLVCompDoorDetail, " required to save Datasheet."));
              }
              if(this.dsPanelObj.isForceCoolingApplicable){
                _validList.push(new ValidationItem("VCB Current", !!this.dsPanelObj.forceCoolingVCBCurr, " required to save Datasheet."));
                _validList.push(new ValidationItem("Force Cooling Fan", !!this.dsPanelObj.forceCoolingFan, " required to save Datasheet."));
                _validList.push(new ValidationItem("No of Fans", !!this.dsPanelObj.noOfFans, " required to save Datasheet."));
                _validList.push(new ValidationItem("Location of Fans", !!this.dsPanelObj.locationofFans, " required to save Datasheet."));
              }
              if(this.dsPanelObj.isExhTypeApplicable){
                 _validList.push(new ValidationItem("Type", !!this.dsPanelObj.exhType, " required to save Datasheet."));
                 _validList.push(new ValidationItem("Details", !!this.dsPanelObj.exhTypeDetail, " required to save Datasheet."));
                }
              if (this.dsPanelObj.isCastleLockPhilosophyApplicable) {
               _validList.push(new ValidationItem("Castle Lock Philosophy", !!this.dsPanelObj.castleLockPhilosophy, " required to save Datasheet."));
              }
            }

            // EE access group (fields with hasAccessEE)
            if (this.hasAccessEE) {
              _validList.push(
                new ValidationItem("EE Note", !!this.dsPanelObj.sectionNoteEE, " required to save Datasheet.")
              );
            }

            // General validations (always checked)
            _validList.push(
              new ValidationItem("Type of Panel", !!this.dsPanelObj.dsPanelType, " required to save Datasheet."),
              new ValidationItem("Product Type", !!this.dsPanelObj.prodType, " required to save Datasheet."),
              new ValidationItem("Front Doors and End Covers", !!this.dsPanelObj.frontDoorEndCover, " required to save Datasheet."),
              new ValidationItem("Rest of the Panel", !!this.dsPanelObj.restOfPanel, " required to save Datasheet."),
              new ValidationItem("Sheet Thickness for Enclosure", !!this.dsPanelObj.sheetThickForEnc, " required to save Datasheet."),
              new ValidationItem("LV Compartment Door", !!this.dsPanelObj.lvCompDoorV2, " required to save Datasheet."),
              new ValidationItem("Breaker Compartment Door", !!this.dsPanelObj.breakerCompDoor, " required to save Datasheet."),
              new ValidationItem("Lifting Arrangement", !!this.dsPanelObj.liftArrg, " required to save Datasheet."),
              new ValidationItem("3 Core Cables", !!this.dsPanelObj.coreCables_3, " required to save Datasheet.")
            );

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);

    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
       
  }

  saveSOValidation(): boolean {
    // PM critical fields
    if (this.hasAccessPM) {
      if (!this.dsPanelObj.vcbModelName || !this.dsPanelObj.rackInOutMech || !this.dsPanelObj.sectionNotePM) {
        return false;
      }
      if(this.dsPanelObj.isVcbSpecReqApplicable){
        if(!this.dsPanelObj.vcbModelDetail){
          return false;
        }
      }
    }

    // ME critical fields
    if (this.hasAccessME) {
      if (!this.dsPanelObj.vcbType || !this.dsPanelObj.vcbPole || !this.dsPanelObj.forEnclosure || !this.dsPanelObj.forLVCompDoor ||
        !this.dsPanelObj.castleLock ||
        !this.dsPanelObj.rearCover || !this.dsPanelObj.extBothSides || !this.dsPanelObj.powerCable ||
        !this.dsPanelObj.controlCable || !this.dsPanelObj.busduct || !this.dsPanelObj.singleCoreCables || !this.dsPanelObj.gasductExh || !this.dsPanelObj.forceCoolingApplic ||
        !this.dsPanelObj.exhType || !this.dsPanelObj.exhTypeDetail || !this.dsPanelObj.silverPlatingatJoints || !this.dsPanelObj.sectionNoteME) {
        return false;
      }
      if(this.dsPanelObj.isBusductApplicable){
        if(!this.dsPanelObj.busductEntry || !this.dsPanelObj.feederNameAppli){
          return false;
        }
      }
      if(this.dsPanelObj.isLvCompDrSpecReqApplicable){
        if(!this.dsPanelObj.forLVCompDoorDetail){
          return false;
        }
      }
      if(this.dsPanelObj.isForceCoolingApplicable){
        if(!this.dsPanelObj.forceCoolingVCBCurr || !this.dsPanelObj.forceCoolingFan || !this.dsPanelObj.noOfFans || !this.dsPanelObj.locationofFans){
          return false;
        }
      }
      if(this.dsPanelObj.isExhTypeApplicable){
          if(!this.dsPanelObj.exhType || !this.dsPanelObj.exhTypeDetail){
            return false;
          }
      }
      if (this.dsPanelObj.isCastleLockPhilosophyApplicable) {
        if (!this.dsPanelObj.castleLockPhilosophy) {
          return false;
        }
      }
    }

    // EE critical fields
    if (this.hasAccessEE) {
      if (!this.dsPanelObj.sectionNoteEE) {
        return false;
      }
    }
    return true;
  }
  

}

